import CalendlyWidget from './CalendlyWidget';
import AcuityWidget from './AcuityWidget';

class NullWidget {
  showPopup() {}

  closePopup() {}

  setUrl() {}

  connect() {}

  disconnect() {}
}

const CreateSchedulingWidget = ({ type, url, payload, onEventScheduled }) => {
  const params = { url, payload, onEventScheduled };

  switch (String(type).toLowerCase()) {
    case 'calendly':
      return new CalendlyWidget(params);
    case 'acuity':
      return new AcuityWidget(params);
    default:
      return new NullWidget(params);
  }
};

export default CreateSchedulingWidget;
